import { formatDataValue } from 'utils/formatFns';

export const manufacturingFields = {
  actualAssembly: {
    label: 'Act. Assembly',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.actualAssemblyEndDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  actualBody: {
    label: 'Act. Body',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.actualBodyEndDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  actualBuildDate: {
    label: 'Act. Build Date',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.actualBuildDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  actualBuildWeek: {
    label: 'Act. Build Week',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.actualBuildWeekNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  actualPaint: {
    label: 'Act. Paint',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.actualPaintEndDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  domesticImport: {
    label: 'Domestic/Import',
    getValue: (data) => data?.manufacturing?.plantInformation?.napCbuCode,
    formatValue: (value) => (value ? formatDataValue({ value }) : null),
  },
  estimatedBuildDate: {
    label: 'Est. Build Date',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.estimatedBuildDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  estimatedBuildWeek: {
    label: 'Est. Build Week',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.estimatedBuildWeekNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  estimatedProdDate: {
    label: 'Est. Prod Date',
    getValue: (data) =>
      data?.manufacturing?.keyProductionDates?.actualBuildDateFmt ||
      data?.manufacturing?.keyProductionDates?.estimatedBuildDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  finalAssemblyLocation: {
    label: 'Final Assembly Location',
    getValue: (data) => data?.manufacturing?.plantInformation?.finalAssemblyLocation,
    formatValue: (value) => formatDataValue({ value }),
  },
  location: {
    label: 'Location',
    getValue: (data) => data?.manufacturing?.plantInformation?.plantName,
    formatValue: (value) => formatDataValue({ value }),
  },
  manufacturingRegion: {
    label: 'Manufacturing Region',
    getValue: (data) => data?.manufacturing?.plantInformation?.regionName,
    formatValue: (value) => formatDataValue({ value }),
  },
  offlineDate: {
    label: 'Offline Date',
    getValue: (data) => data?.manufacturing?.offlineTimestampFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  onlineDate: {
    label: 'Online Date',
    getValue: (data) => data?.manufacturing?.onlineTimestampFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  onlineTimestamp: {
    label: 'Online Timestamp',
    getValue: (data) => data?.manufacturing?.onlineTimestampFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  plantCodeName: {
    label: 'Plant Code | Name',
    getValue: (data) => ({
      plantCode: data?.manufacturing?.plantInformation?.globalPlantSourceCode,
      plantDescription: data?.manufacturing?.plantInformation?.plantDescription,
    }),
    formatValue: ({ plantCode, plantDescription }) => {
      const formattedCode = formatDataValue({ value: plantCode });
      const formattedDescription = formatDataValue({ value: plantDescription });
      return `${formattedCode} | ${formattedDescription}`;
    },
  },
  plantLineDescription: {
    label: 'Plant Line | Description',
    getValue: (data) => ({
      plantLinePath: data?.manufacturing?.plantInformation?.plantLinePath,
      plantLinePathDescription: data?.manufacturing?.plantInformation?.plantLinePathDescription,
    }),
    formatValue: ({ plantLinePath, plantLinePathDescription }) => {
      const formattedPath = formatDataValue({ value: plantLinePath });
      const formattedDescription = formatDataValue({ value: plantLinePathDescription });
      return `${formattedPath}  |  ${formattedDescription}`;
    },
  },
  plantReferenceNumber: {
    label: 'Plant Ref. Number',
    getValue: (data) => data?.manufacturing?.plantReferenceNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  prodLockDate: {
    label: 'Prod. Lock Date',
    getValue: (data) => data?.manufacturing?.keyProductionDates?.dailyProductionLockDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
};
